;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/deals/:id\",\"regex\":\"^/deals/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/invite/:token\",\"regex\":\"^/invite/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/reset-password/:token\",\"regex\":\"^/reset-password/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/dashboard\"},{\"path\":\"/deals/new\"},{\"path\":\"/dev/app-nav-logout\"},{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/register\"},{\"path\":\"/settings/billing\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.9";import * as Sentry from "@sentry/nextjs";
import { getClientSentryDsn, getSharedSentryOptions } from "./lib/sentry";

try {
  const dsn = getClientSentryDsn();
  if (dsn) {
    Sentry.init(getSharedSentryOptions(dsn));
  }
} catch {
  // Fail-open: missing or invalid Sentry config must never block the app.
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
